/*
 * VPDB - Virtual Pinball Database
 * Copyright (C) 2019 freezy <freezy@vpdb.io>
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 * Modified for sigmashake-pinball by SigmaShake, 2026.
 */

/**
 * Item type numbers used by the engine.
 *
 * Upstream these are classes with a script API. Here they are plain constant
 * objects. The names follow the upstream names, except the two kicker types
 * that carry a vendor name upstream.
 */

export const LightStatus = {
  LightStateOff: 0,
  LightStateOn: 1,
  LightStateBlinking: 2,
} as const;

export const TriggerShape = {
  TriggerNone: 0,
  TriggerWireA: 1,
  TriggerStar: 2,
  TriggerWireB: 3,
  TriggerButton: 4,
  TriggerWireC: 5,
  TriggerWireD: 6,
} as const;

export const RampType = {
  RampTypeFlat: 0,
  RampType4Wire: 1,
  RampType2Wire: 2,
  RampType3WireLeft: 3,
  RampType3WireRight: 4,
  RampType1Wire: 5,
} as const;

export const PlungerType = {
  PlungerTypeModern: 1,
  PlungerTypeFlat: 2,
} as const;

export const TargetType = {
  DropTargetBeveled: 1,
  DropTargetSimple: 2,
  HitTargetRound: 3,
  HitTargetRectangle: 4,
  HitFatTargetRectangle: 5,
  HitFatTargetSquare: 6,
  DropTargetFlatSimple: 7,
  HitFatTargetSlim: 8,
  HitTargetSlim: 9,
} as const;

export const GateType = {
  GateWireW: 1,
  GateWireRectangle: 2,
  GatePlate: 3,
  GateLongPlate: 4,
} as const;

export const KickerType = {
  KickerInvisible: 0,
  KickerHole: 1,
  KickerCup: 2,
  KickerHoleSimple: 3,
  /** Reserved. The contracts do not use type 4. */
  KickerReservedA: 4,
  /** Reserved. The contracts do not use type 5. */
  KickerReservedB: 5,
  KickerCup2: 6,
} as const;

export const RampImageAlignment = {
  ImageModeWorld: 0,
  ImageModeWrap: 1,
} as const;

/** All enums in one object. Upstream code reads `Enums.RampType.RampTypeFlat`. */
export const Enums = {
  LightStatus,
  TriggerShape,
  RampType,
  PlungerType,
  TargetType,
  GateType,
  KickerType,
  RampImageAlignment,
} as const;
